export default {
    namespaced: true,
    state() {
        return {
            quotes: [],
            quote: window?.data?.order?.quote,
        }
    },
    getters: {
        completed(state) {
            return !!state.quote;
        },
        form(state) {
            return {
                service: state.quote.service
            }
        },
    },
    actions: {
        searchQuotes({commit}, data) {
            api.quote.search(data).then(
                response => commit('setQuotes', response.data.data)
            )
        },
    },
    mutations: {
        setQuotes(state, quotes) {
            state.quotes = quotes;
        },
        setQuote(state, quote) {
            state.quote = quote;
        },
    },
}
